import request from '@/utils/request'
const BASE_URL = '/pdd/malladdresses'

export default {
  getSender() {
    return request({
      url: BASE_URL + '/sender',
      method: 'get',
      headers: { 'UnCheck': 'uncheck' }
    })
  },
  postSender(data) {
    return request({
      url: BASE_URL + '/sender',
      method: 'post',
      headers: { 'UnCheck': 'uncheck' },
      data
    })
  },
  putSender(data) {
    return request({
      url: BASE_URL + '/sender',
      method: 'put',
      headers: { 'UnCheck': 'uncheck' },
      data
    })
  },
  delSender(data) {
    return request({
      url: BASE_URL + '/sender',
      method: 'delete',
      headers: { 'UnCheck': 'uncheck' },
      data
    })
  },
}